import { stackPresets } from '~/lib/tech-spec/stack-presets';
import type { TechStackConfig } from '~/lib/tech-spec/types';

interface Props {
  current: TechStackConfig;
  onChange: (stack: TechStackConfig) => void;
}

function isPresetActive(current: TechStackConfig, preset: TechStackConfig) {
  return (Object.keys(preset) as (keyof TechStackConfig)[]).every(
    (k) => current[k] === preset[k],
  );
}

export default function StackPresetPicker({ current, onChange }: Props) {
  return (
    <div className="flex flex-wrap gap-2">
      {stackPresets.map((preset) => {
        const active = isPresetActive(current, preset.stack);
        return (
          <button
            key={preset.id}
            type="button"
            onClick={() => onChange(preset.stack)}
            title={preset.description}
            className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-colors ${
              active
                ? 'bg-indigo-600 border-indigo-600 text-white'
                : 'bg-white border-gray-200 text-gray-600 hover:border-indigo-300 hover:text-indigo-700'
            }`}
          >
            {preset.name}
          </button>
        );
      })}
    </div>
  );
}
